import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from '@mui/material';

const NotesDialog = ({
  open,
  onClose,
  currentNote,
  setCurrentNote,
  addNote,
  editingIndex
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth disableEnforceFocus>
      <DialogTitle>{editingIndex !== null ? 'Edit Note' : 'Add Notes'}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            label="Time (minutes)"
            type="number"
            value={currentNote.time}
            onChange={(e) => setCurrentNote(prev => ({ ...prev, time: e.target.value }))}
            inputProps={{ min: 0 }}
            fullWidth
          />
          <TextField
            label="Notes"
            multiline
            rows={4}
            value={currentNote.note}
            onChange={(e) => setCurrentNote(prev => ({ ...prev, note: e.target.value }))}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={addNote} variant="contained">Add Note</Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotesDialog;